import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Index',
        meta: {
            title: '可信时间戳证据分享'
        },
        component: Index
    },
    {
        path: '/FileShow',
        name: 'FileShow',
        meta: {
            title: '可信时间戳证据分享'
        },
        component: () =>
            import ( /* webpackChunkName: "fileShow" */ '../views/FileShow.vue')
    },
    {
        path: '/Error',
        name: 'Error',
        meta: {
            title: '时间戳_联合信任时间戳服务中心_TSA_电子证据_权利卫士_知识产权保护'
        },
        component: () =>
            import ( /* webpackChunkName: "fileShow" */ '../views/Overdue.vue'),
    }
    
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router